export default __webpack_public_path__ + "static/media/player-leah-colour-desk@2x.0e72ecf0.png";